import home from "./home";
import utils from "./utils";

export default {
  home,
  utils,
};
